export var input = {
  display: 'inline-block',
  height: 30,
  padding: '4px 6px',
  marginBottom: 0,
  marginLeft: 0,
  fontSize: 14,
  lineHeight: '20px',
  WebkitBorderRadius: 4,
  MozBorderRadius: 4,
  borderRadius: 4,
  verticalAlign: 'middle',
};

export var container = {
  paddingLeft: 20,
  marginBottom: 8,
  display: 'flex',
  flexDirection: 'row',
  gap: '.5rem',
};

export var description = {
  paddingLeft: 2,
};

export var checkbox = {
  width: 22,
  height: 20,
  fontSize: 20,
  paddingLeft: 2,
};

export var link = {
  cursor: 'pointer',
};
